var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{ref:"uploader",attrs:{"name":"file","action":_vm.uploadUrl,"multiple":true,"list-type":"picture-card","customRequest":_vm.handleHttpRequest,"before-upload":_vm.beforeUpload,"remove":_vm.removeFile,"file-list":_vm.fileList}},[_c('a-icon',{attrs:{"type":_vm.loading ? 'loading' : 'plus'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }